import { BaseObservableForm } from "apps-module/app/shared-library/forms/base-observable.form";
import { FormControl, FormGroup } from "@angular/forms";
import { nameof } from "apps-module/app/shared-library/utils/common.utils";
import _merge from "lodash/merge";
import { FormSearchParametersModel } from "apps-module/app/entry-modules/vacancies-search/models/form-search-parameters.model";

export class SearchForm extends BaseObservableForm<FormSearchParametersModel> {
    public static createForm(initialSearchParams: FormSearchParametersModel): SearchForm {
        const formGroup = new FormGroup({
            pageNumber: new FormControl<number>(initialSearchParams.pageNumber),
            pageId: new FormControl<number>(initialSearchParams.pageId)
        });

        return new SearchForm(formGroup, initialSearchParams);
    }

    public get nativeForm(): FormGroup { return this.formInstance; }

    public get pageNumber(): FormControl<number> { return this.formInstance.get(nameof<FormSearchParametersModel>("pageNumber")) as FormControl<number>; }
    public get pageId(): FormControl<string> { return this.formInstance.get(nameof<FormSearchParametersModel>("pageId")) as FormControl<string>; }
    public get searchText(): FormControl<string> { return this.formInstance.get(nameof<FormSearchParametersModel>("searchText")) as FormControl<string>; }
    public get location(): FormControl<string> { return this.formInstance.get(nameof<FormSearchParametersModel>("location")) as FormControl<string>; }
    public get jobType(): FormControl<string> { return this.formInstance.get(nameof<FormSearchParametersModel>("jobType")) as FormControl<string>; }
    public get fromDate(): FormControl<string> { return this.formInstance.get(nameof<FormSearchParametersModel>("fromDate")) as FormControl<string>; }
    public get toDate(): FormControl<string> { return this.formInstance.get(nameof<FormSearchParametersModel>("toDate")) as FormControl<string>; }

    private constructor(
        formInstance: FormGroup,
        initialSearchParams: FormSearchParametersModel
    ) {
        super(formInstance, initialSearchParams);
    }

    public searchByPageNumber(): void {
        this.submit({
            searchText: this.initialFormState.searchText,
            location: this.initialFormState.location,
            jobType: this.initialFormState.jobType,
            fromDate: this.initialFormState.fromDate,
            toDate: this.initialFormState.toDate
        });
    }

    public searchByFilters(): void {
        this.submit({
            pageNumber: 1,
            searchText: this.initialFormState.searchText
        });
    }

    public searchByText(): void {
        this.submit({
            pageNumber: 1,
            location: this.initialFormState.location,
            jobType: this.initialFormState.jobType,
            fromDate: this.initialFormState.fromDate,
            toDate: this.initialFormState.toDate
        });
    }
}
